import { Component, h, Method, Prop, State } from '@stencil/core';


@Component({
    tag: 'app-accordion',
    styleUrl: 'app-accordion.scss',
    shadow: false,
})
export class AppAccordion {

    @Prop() accordionTitle: string;
    @Prop() accordionId: string;
    @Prop() startOpen: boolean = false;
    @State() open: boolean = false;

    componentWillLoad() {
        this.open = this.startOpen;

        // If not id is provided, generate one using the accordion title.
        if (!this.accordionId) {
            this.accordionId = this.accordionTitle.replace(/[^A-Z0-9]/ig, "-");
        }

        // If hash matches this accordion, start it open.
        if (window.location.hash && window.location.hash.toLowerCase() == '#' + this.accordionId.toLowerCase()) {
            this.open = true;
        }
    }

    componentDidLoad() {
        if (window.innerWidth < 1199.98) {
            this.closeOtherAccordions();
            this.openFirstAccordion()
        }
        const mediaQuery = window.matchMedia('(max-width: 1199.98px)');
        mediaQuery.addEventListener('change', (event) => {
            if (event.matches) {
                // Screen width is smaller than 1199.98
                this.closeOtherAccordions();
                this.openFirstAccordion()
            }
        });
    }

    toggleAccordion() {
        this.closeOtherAccordions();
        this.open = !this.open;
    }

    closeOtherAccordions() {
        const accordions = document.querySelectorAll('app-accordion');

        accordions.forEach((accordion) => {
            if (accordion.accordionId != this.accordionId) {
                accordion.closeAccordion();
            }
        });
    }

    openFirstAccordion() {
        const accordions = document.querySelectorAll('app-accordion');

        accordions[0].openAccordion();
    }

    @Method() async closeAccordion() {
        this.open = false;
    }

    @Method() async openAccordion() {
        this.open = true;
    }

    render() {
        return (
            <div class={`app-accordion ${this.open ? 'open' : ''}`}>
                <h3
                    id={this.accordionId}
                    aria-label={`View ${this.accordionTitle}`}
                    role="button"
                    tabIndex={0}
                    onClick={() => { this.toggleAccordion() }}
                    onKeyPress={(e) => e.keyCode == 13 ? this.toggleAccordion() : null}>


                    {this.accordionTitle}
                    <span class="icon">
                        <svg>
                            <use href="/themes/custom/qsci/frontend/www/assets/icon/sheets/icons.svg#chevron-down"></use>
                        </svg>
                    </span>
                </h3>

                <div class="app-accordion-content" aria-describedby={this.accordionId}>
                    <div class="app-accordion-content-inner">
                        <slot />
                    </div>
                </div>
            </div>
        );
    }

}
